import { createTheme } from './createTheme';
import { DARK_MODE, GRAY_SCALE } from 'constants/ThemeConstant';
import { rgba, mixOnBackground, createOpaqueTableRowColors, buildOpaqueTableRowScopedStyles, getTableRowTokens, getColoredHeaderTableTokens, buildThemeTableSorterScopedStyles, buildThemeCheckboxScopedStyles, buildThemeGroupRowCssVariables } from './utils';

const WOMEN_PRIMARY = '#E74381';
const WOMEN_BG = '#FFDAEA';
const WOMEN_TEXT = '#531D1D';
const WOMEN_BORDER = '#FFD6E7';
/** Màu nền group-row table */
const WOMEN_GROUP = mixOnBackground(WOMEN_PRIMARY, 0.7, GRAY_SCALE.WHITE);
const WOMEN_MODULE_ICON = GRAY_SCALE.WHITE;
/** Tiêu đề nhóm menu (NGHIỆP VỤ, TÀI LIỆU) — tông nhạt của màu chính */
const WOMEN_MENU_GROUP_TITLE = mixOnBackground(WOMEN_PRIMARY, 0.3, GRAY_SCALE.WHITE);
const WOMEN_TABLE_ROW_COLORS = createOpaqueTableRowColors(WOMEN_PRIMARY, GRAY_SCALE.WHITE);
/** Sidebar custom-menu — không dùng token Menu global */
export const womenDayCustomMenuStyles = `
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected),
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected) .anticon,
.side-nav .custom-menu .ant-menu-item:not(.ant-menu-item-selected) .ant-menu-item-icon,
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .anticon,
.side-nav .custom-menu .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .ant-menu-item-icon {
    color: ${WOMEN_MODULE_ICON} !important;
}
.side-nav .custom-menu .ant-menu-item-group-title,
.side-nav .custom-menu .ant-menu-item-group-title .nav-item_title {
    color: ${WOMEN_MENU_GROUP_TITLE} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected),
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open):not(.ant-menu-submenu-active) > .ant-menu-submenu-title {
    color: ${GRAY_SCALE.WHITE} !important;
}
.custom-menu-popup.ant-menu-dark .ant-menu-item:not(.ant-menu-item-selected) .anticon,
.custom-menu-popup.ant-menu-dark .ant-menu-submenu:not(.ant-menu-submenu-selected):not(.ant-menu-submenu-open) > .ant-menu-submenu-title .anticon {
    color: ${WOMEN_MODULE_ICON} !important;
}
`;

/** Steps điều hướng form (className="step-nav") */
export const womenDayStepNavStyles = `
.step-nav.ant-steps .ant-steps-item-title {
    color: ${WOMEN_TEXT} !important;
    font-size: 13px !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-title,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: ${WOMEN_PRIMARY} !important;
    font-weight: 600 !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${WOMEN_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-process .ant-steps-item-icon .anticon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-finish .ant-steps-item-icon .anticon {
    color: ${WOMEN_PRIMARY} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
    background-color: transparent !important;
    border-color: ${WOMEN_BORDER} !important;
}
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon,
.step-nav.ant-steps .ant-steps-item-wait .ant-steps-item-icon .anticon {
    color: ${GRAY_SCALE.GRAY} !important;
}
`;

export const womenDayScopedStyles = `
${womenDayCustomMenuStyles}
${womenDayStepNavStyles}
.ant-table-wrapper .ant-table-thead > tr > th {
    font-weight: 600;
    text-transform: uppercase;
}
${buildThemeTableSorterScopedStyles(WOMEN_PRIMARY)}
${buildOpaqueTableRowScopedStyles(WOMEN_TABLE_ROW_COLORS)}
${buildThemeCheckboxScopedStyles('light')}
${buildThemeGroupRowCssVariables(WOMEN_PRIMARY, WOMEN_GROUP, 'light', WOMEN_BG)}
`;

export const womenDayTheme = createTheme({
    primaryColor: WOMEN_PRIMARY,
    successColor: '#FF85C0',
    warningColor: '#FFC0CB',
    errorColor: '#FF4D4F',
    bgColor: WOMEN_BG,
    textColor: WOMEN_TEXT,
    borderColor: WOMEN_BORDER,
    bodyBg: WOMEN_BG,
    colorBgLayout: WOMEN_BG,
    menuGroupTitleColor: WOMEN_MENU_GROUP_TITLE,
    moduleMenuBg: WOMEN_PRIMARY,
    moduleMenuIconColor: WOMEN_MODULE_ICON,
    moduleMenuItemColor: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedBg: GRAY_SCALE.WHITE,
    moduleMenuItemSelectedColor: WOMEN_PRIMARY,
    moduleMenuItemSelectedBorderColor: WOMEN_PRIMARY,
    headerNavColor: WOMEN_BG,
    siderBg: GRAY_SCALE.WHITE,
    customMenuBg: GRAY_SCALE.WHITE,
    customMenuItemSelectedColor: WOMEN_TEXT,
    customMenuItemSelectedBg: GRAY_SCALE.WHITE,
    customMenuItemSelectedIconColor: WOMEN_PRIMARY,
    customMenuItemSelectedBorderColor: GRAY_SCALE.WHITE,

    footerBg: WOMEN_PRIMARY,
    footerTextColor: GRAY_SCALE.WHITE,

    componentOverrides: {
        Layout: {
            bodyBg: WOMEN_BG,
            headerBg: WOMEN_BG,
            siderBg: GRAY_SCALE.WHITE,
        },
        Menu: {
            darkItemBg: 'transparent',
            darkItemColor: GRAY_SCALE.WHITE,
            darkItemSelectedBg: DARK_MODE.ACTIVE_BG_COLOR,
            darkItemSelectedColor: GRAY_SCALE.WHITE,
            darkItemHoverBg: DARK_MODE.HOVER_BG_COLOR,
            darkItemHoverColor: GRAY_SCALE.GRAY_DARK,
            darkSubMenuItemBg: DARK_MODE.BG_COLOR,
            popupBg: DARK_MODE.BG_COLOR,
            activeBarWidth: 0,
            boxShadowSecondary: DARK_MODE.DROP_DOWN_SHADOW,
        },
        Breadcrumb: {
            itemColor: GRAY_SCALE.GRAY,
            lastItemColor: WOMEN_PRIMARY,
            linkColor: GRAY_SCALE.GRAY,
            linkHoverColor: WOMEN_PRIMARY,
            separatorColor: GRAY_SCALE.GRAY,
        },
        Card: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorTextHeading: WOMEN_PRIMARY,
            colorText: WOMEN_TEXT,
            colorBorderSecondary: WOMEN_BORDER,
            extraColor: WOMEN_TEXT,
            headerBg: GRAY_SCALE.WHITE,
            actionsBg: GRAY_SCALE.WHITE,
            borderRadiusLG: 22,
        },
        Table: {
            colorText: WOMEN_TEXT,
            colorTextHeading: GRAY_SCALE.WHITE,
            headerBg: WOMEN_PRIMARY,
            borderColor: '#F0F0F0',
            ...getColoredHeaderTableTokens(WOMEN_PRIMARY),
            ...getTableRowTokens(WOMEN_TABLE_ROW_COLORS),
        },
        Steps: {
            colorPrimary: WOMEN_PRIMARY,
            colorText: WOMEN_TEXT,
            colorTextDescription: GRAY_SCALE.GRAY,
        },
        Input: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: WOMEN_BORDER,
            activeBorderColor: WOMEN_PRIMARY,
            hoverBorderColor: WOMEN_PRIMARY,
        },
        DatePicker: {
            colorBgContainer: GRAY_SCALE.WHITE,
            colorBorder: WOMEN_BORDER,
            activeBorderColor: WOMEN_PRIMARY,
            hoverBorderColor: WOMEN_PRIMARY,
        },
        Button: {
            defaultBg: GRAY_SCALE.WHITE,
            defaultHoverBg: GRAY_SCALE.WHITE,
            defaultActiveBg: GRAY_SCALE.WHITE,
            defaultBorderColor: WOMEN_BORDER,
            defaultHoverBorderColor: WOMEN_PRIMARY,
            defaultActiveBorderColor: WOMEN_PRIMARY,
        },
        Dropdown: {
            colorBgElevated: GRAY_SCALE.WHITE,
            colorText: WOMEN_TEXT,
            colorPrimary: WOMEN_PRIMARY,
            controlItemBgHover: rgba(WOMEN_PRIMARY, 0.06),
            controlItemBgActive: rgba(WOMEN_PRIMARY, 0.1),
            controlItemBgActiveHover: rgba(WOMEN_PRIMARY, 0.14),
        },
        Select: {
            colorBgContainer: GRAY_SCALE.WHITE,
            selectorBg: GRAY_SCALE.WHITE,
            colorBgElevated: GRAY_SCALE.WHITE,
            optionSelectedBg: rgba(WOMEN_PRIMARY, 0.1),
            optionActiveBg: rgba(WOMEN_PRIMARY, 0.06),
            colorBorder: WOMEN_BORDER,
            activeBorderColor: WOMEN_PRIMARY,
            hoverBorderColor: WOMEN_PRIMARY,
        },
    },
});
